/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Setting,
  Setting$inboundSchema,
  Setting$Outbound,
  Setting$outboundSchema,
} from "./setting.js";

/**
 * Websocket event type
 */
export const SettingEventType = {
  AlarmActivation: "alarm_activation",
  Error: "error",
  Keepalive: "keepalive",
  Reading: "reading",
  Setting: "setting",
  ShutdownBanner: "shutdown_banner",
  Trends: "trends",
  UserActivity: "user_activity",
} as const;
/**
 * Websocket event type
 */
export type SettingEventType = OpenEnum<typeof SettingEventType>;

/**
 * Stream of settings
 */
export type SettingEvent = {
  /**
   * The trace metadata, initialized by the trace stream interceptor
   */
  traceMetadata?: { [k: string]: string } | undefined;
  /**
   * Updated Settings
   */
  settings?: Array<Setting> | undefined;
  /**
   * Websocket event type
   */
  type?: SettingEventType | undefined;
};

/** @internal */
export const SettingEventType$inboundSchema: z.ZodType<
  SettingEventType,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(SettingEventType);
/** @internal */
export const SettingEventType$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  SettingEventType
> = openEnums.outboundSchema(SettingEventType);

/** @internal */
export const SettingEvent$inboundSchema: z.ZodType<
  SettingEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  TraceMetadata: types.optional(z.record(types.string())),
  settings: types.optional(z.array(Setting$inboundSchema)),
  type: SettingEventType$inboundSchema.default("setting"),
}).transform((v) => {
  return remap$(v, {
    "TraceMetadata": "traceMetadata",
  });
});
/** @internal */
export type SettingEvent$Outbound = {
  TraceMetadata?: { [k: string]: string } | undefined;
  settings?: Array<Setting$Outbound> | undefined;
  type: string;
};

/** @internal */
export const SettingEvent$outboundSchema: z.ZodType<
  SettingEvent$Outbound,
  z.ZodTypeDef,
  SettingEvent
> = z.object({
  traceMetadata: z.record(z.string()).optional(),
  settings: z.array(Setting$outboundSchema).optional(),
  type: SettingEventType$outboundSchema.default("setting"),
}).transform((v) => {
  return remap$(v, {
    traceMetadata: "TraceMetadata",
  });
});

export function settingEventToJSON(settingEvent: SettingEvent): string {
  return JSON.stringify(SettingEvent$outboundSchema.parse(settingEvent));
}
export function settingEventFromJSON(
  jsonString: string,
): SafeParseResult<SettingEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SettingEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SettingEvent' from JSON`,
  );
}
